module.exports = __webpack_public_path__ + "assets/door-32-rested.svg";